/** Fine-grained capabilities for the customer console (per logged-in user organizationRole). */

export const PERMISSIONS = {
  NAV_OVERVIEW: 'nav.overview',
  NAV_USERS: 'nav.users',
  NAV_TRANSACTIONS: 'nav.transactions',
  NAV_CHARTS: 'nav.charts',
  NAV_PRODUCTS: 'nav.products',
  NAV_WEBHOOKS: 'nav.webhooks',
  NAV_CONSUMPTION: 'nav.consumption',
  NAV_MAILING: 'nav.mailing',
  NAV_ABTESTS: 'nav.abtests',
  /**
   * Retention messaging configuration. Separate from FEATURE_SUBSCRIPTION_RETENTION, which
   * gates the retention *charts* — this one writes the words Apple shows a cancelling
   * subscriber, so it belongs to whoever owns the copy, not to whoever reads the numbers.
   */
  NAV_RETENTION_MESSAGING: 'nav.retention_messaging',
  FEATURE_LTV: 'feature.ltv',
  FEATURE_SUBSCRIPTION_RETENTION: 'feature.subscription_retention',
  /**
   * Org kullanıcıları / onboarding — sadece organizationRole === customer_admin.
   * Wildcard (*) ile diğer rollere verilemez; hasOrganizationPermission bunu ayrı doğrular.
   */
  ADMIN_CUSTOMER_ADMIN_ONLY: 'admin.customer_admin_only',
  /** Mobeat internal — demo request inbox only */
  NAV_DEMO_LEADS: 'nav.demo_leads',
};

const P = PERMISSIONS;

const ALL_APP = [
  P.NAV_OVERVIEW,
  P.NAV_USERS,
  P.NAV_TRANSACTIONS,
  P.NAV_CHARTS,
  P.NAV_PRODUCTS,
  P.NAV_WEBHOOKS,
  P.NAV_CONSUMPTION,
  P.NAV_MAILING,
  P.NAV_ABTESTS,
  P.NAV_RETENTION_MESSAGING,
  P.FEATURE_LTV,
  P.FEATURE_SUBSCRIPTION_RETENTION,
];

/** role id → permission strings (no wildcard expansion on client except customer_admin). */
export const ROLE_PERMISSIONS = {
  customer_admin: ['*'],
  developer: [...ALL_APP],
  marketing: [
    P.NAV_OVERVIEW,
    P.NAV_USERS,
    P.NAV_TRANSACTIONS,
    P.NAV_CHARTS,
    P.NAV_MAILING,
    P.NAV_RETENTION_MESSAGING,
    P.FEATURE_LTV,
    P.FEATURE_SUBSCRIPTION_RETENTION,
  ],
  analyst: [
    P.NAV_OVERVIEW,
    P.NAV_USERS,
    P.NAV_TRANSACTIONS,
    P.NAV_CHARTS,
    P.NAV_PRODUCTS,
    P.NAV_CONSUMPTION,
    P.FEATURE_LTV,
    P.FEATURE_SUBSCRIPTION_RETENTION,
  ],
  mobeat_staff: [P.NAV_DEMO_LEADS],
};

export const ORGANIZATION_ROLE_OPTIONS = [
  { value: 'customer_admin', label: 'Customer admin' },
  { value: 'developer', label: 'Developer' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'analyst', label: 'Analyst' },
];

/**
 * @param {string|undefined|null} role
 * @param {string[]} required — empty / missing → allowed
 */
export function hasOrganizationPermission(role, required) {
  if (!required?.length) {
    return true;
  }
  const r = role || 'customer_admin';
  const allowed = ROLE_PERMISSIONS[r];
  if (!allowed?.length) {
    return false;
  }

  return required.every((p) => {
    if (p === PERMISSIONS.ADMIN_CUSTOMER_ADMIN_ONLY) {
      return r === 'customer_admin';
    }
    if (allowed.includes('*')) {
      return true;
    }
    return allowed.includes(p);
  });
}
